define( 'VerticalSlider',[ 'jquery', 'Swiper', 'ANSI/Utility/Dimensions', 'ANSI/Utility/SitecoreUtils', 'promise-polyfill', 'matchHeight' ], function ( $, Swiper, dimensions, sitecoreUtils ) {
    'use strict';
    var verticalSlider = {
        init: function () {
            if ( $( '.ansi-vertical-carousel' ).length ) {
                $( '.ansi-vertical-carousel .offset-container.swiper-slide' ).matchHeight( { byRow: false } );
                verticalSlider.resizeSwiper();
                verticalSlider.animate();
            }
        },
        resizeSwiper: function () {
            $( '.swiper-container' ).height( $( '.offset-container.swiper-slide' ).height() );
        },
        animate: function () {
            var swiper = new Swiper( '.swiper-container.ansi-vertical-carousel', {
                direction: 'horizontal',
                freeMode: true,
                freeModeSticky: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                },
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',

                    clickable: true
                },
                breakpoints: {
                    992: {

                        direction: 'vertical',
                        spaceBetween: 32
                    }
                }
            } );
        }
    };

    if ( !sitecoreUtils.prototype.isEditing() ) Promise.resolve().then( verticalSlider.init );
} );
